// src/pages/TicketDeliveryManagement/QrScanDelivery/index.tsx
// Mục 8.3 (README_UPDATE.md) — Giao vé bằng đọc mã QR qua ảnh. Dùng chung component
// QrScanSessionPage với scanType = 1 (Giao vé). Server (FinalizeScanSessionCommand) gộp số rời thành
// dải rồi gọi CreateTicketDeliveryCommand + ConfirmTicketDeliveryCommand.
import React from 'react';
import QrScanSessionPage from 'pages/TicketScan/QrScanSessionPage';

const QrScanDeliveryPage: React.FC = () => <QrScanSessionPage scanType={1} />;

export default QrScanDeliveryPage;
